import React, {useEffect, useState} from 'react';
import { Redirect } from 'react-router-dom';
import {clinicianIdFromRefreshAuth, getJwtDecoded} from "../../util/authUtil";
import ApiService from "../../ApiService";

const AuthWrapper = ({ children }) => {

    const [clinicianId, setClinicianId] = useState(null);

    useEffect(() => {
        clinicianIdFromRefreshAuth().then(id => setClinicianId(id));
    }, []);

    useEffect(() => {
        if(!clinicianId) return;
        getJwtDecoded().then(j => j);
        ApiService.getClinicianProfile().then(res => {
            if(res?.data) return;
        }).catch(err => console.log(err));
    }, [clinicianId]);

    // if (!clinicianId) {
    //     return <Redirect to='/login' />;
    // }
    return children;
}
export default AuthWrapper;
